import { Navigate, Outlet } from 'react-router-dom';
import { useSetup } from '../../hooks/useSetup.ts';

/**
 * Sends accounts that still need onboarding (``onboarding_required``) to
 * ``/welcome``; everyone else passes straight through. Waits for the first
 * ``/setup`` answer so a new user doesn't see the app flash first; if it
 * fails the app opens as usual.
 */
export function OnboardingGate() {
  const { data, isPending } = useSetup();
  if (isPending) return null;
  if (data?.onboarding_required) return <Navigate to="/welcome" replace />;
  return <Outlet />;
}
